export default {
explore_by: "按…探索",
explore_by_concepts: "創意",
explore_by_families: "香調家族",
language: "語言",
legal: "法律資訊",
find_any_fragrance: "尋找世界上任何香水。",
title_by_concepts: "按創意探索",
desc_by_concepts: "透過想像你喜歡的顏色或地方找到你的香水",
title_by_families: "按香調家族探索",
desc_by_families: "透過思考…找到你的香水",
expert_reviewed: "專家評審",
ingredients: "成分",
description: "描述",
perfumist: "調香師",
concepts: "概念",
olfactive_family: "香調家族",
main_family: "家族",
sub_family: "子家族",
me_family: "世界香水",
filter_by_family: "家族",
filter_by_brand: "品牌",
filter_by_gender: "性別",
for_him: "男士",
for_her: "女士",
unisex: "中性",
all: "全部",
all_female: "全部",
concepts_list: "概念列表",
no_results_for_this_combination: "沒有適合此組合的香水。",
select_at_least_one_concept: "請至少選擇一個概念",
view_perfumes: "查看香水",
back: "返回",
close: "關閉",
filters: "篩選",
selected_concepts: "已選概念：",
selected_families: "已選家族：",
find_concept: "查找概念...",
smell_of: "帶有…氣息",
touch_of: "帶有一絲",
loading_perfumes: "正在載入香水",
loading_concepts: "正在載入概念",
apply: "套用",
search: "搜尋",
clear_all: "清除全部",
iconic_fragrances: "該家族中的經典香水",
is_there_anybody_here: "你還在嗎？",
continue_previous_session: "是的！繼續",
reset_session: "重新開始體驗",
ingredient_type: "類型",
ingredient_parts: "使用部分",
ingredient_extraction: "萃取方法",
ingredient_first: "經典香水",
history: "歷史",
effect: "生產與效果",
origin: "來源",
iconic_fragrance: "經典香氛",
production: "生產",
loyalty_become_a_member: "加入俱樂部",
loyalty_avolta_link: "https://qr.clubavolta.com/register?source=ctOffline-scDuty_Free-sgAirport&campaign=Fragrance_Finder_Tools"
}